import React from 'react';
import { useFormContext } from 'react-hook-form';
import { RadioInput as RadioInput$1 } from '@panwds/react-ui';

/**
 * For most cases, prefer `RadioGroup`. `RadioInput` gives lower level access for custom layouts and use cases not covered by `RadioGroup`.
 */
function RadioInput({ name, register: registerOptions, ...rest }) {
    const { register } = useFormContext();
    return React.createElement(RadioInput$1, { ...rest, ...register(name, registerOptions) });
}

export { RadioInput };
//# sourceMappingURL=RadioInput.esm.js.map
